import { render, staticRenderFns } from "./NumberKeyboard.vue?vue&type=template&id=9c21142e&scoped=true&"
import script from "./NumberKeyboard.vue?vue&type=script&lang=js&"
export * from "./NumberKeyboard.vue?vue&type=script&lang=js&"
import style0 from "./NumberKeyboard.vue?vue&type=style&index=0&id=9c21142e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c21142e",
  null
  
)

export default component.exports